/**
 * Constants for log stream functionality
 */

/**
 * Log level identifiers for filtering and categorizing log entries
 * @readonly
 * @enum {string}
 */
export const LOG_LEVELS = {
  DEBUG: "DEBUG",
  INFO: "INFO",
  EXTRA: "EXTRA",
  WARNING: "WARNING",
  ERROR: "ERROR",
  NONE: "NONE",
};

/**
 * Color mapping for different log levels with extremely high contrast colors for dark backgrounds
 * @readonly
 * @type {Object.<string, string>}
 */
export const LOG_COLORS = {
  [LOG_LEVELS.DEBUG]: "#89d67a",  // medium green
  [LOG_LEVELS.INFO]: "#FAF9F6",   // off-white
  [LOG_LEVELS.EXTRA]: "#7aa3d6",  // light blue
  [LOG_LEVELS.WARNING]: "#d3d67a", // yellowish green
  [LOG_LEVELS.ERROR]: "#FF4433",  // bright red
  [LOG_LEVELS.NONE]: "#ffffff",   // white
};

/**
 * All available log levels array
 * @readonly
 * @type {string[]}
 */
export const ALL_LOG_LEVELS = Object.values(LOG_LEVELS);
